import { Component, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormGroupDirective } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { environment } from 'src/environments/environment';
import { LoaderService, SecurityService, LoggingService } from 'src/app/services';
import { NotificationType, UserAccount } from 'src/app/models';
import { Helpers } from 'src/app/helpers/helpers';
import { TopNotificationService } from '../top-notification/top-notification.service';
import { CommunicationService } from 'src/app/services/communication.service';
import { Router } from '@angular/router';
import { PortalService, RoutingService } from 'src/app/services';
import { IQuestionModel } from 'src/app/models/communication/questions';

@Component({
    selector: 'medpt-submit-question',
    templateUrl: './submit-question.component.html',
    styleUrls: ['./submit-question.component.scss'],
    standalone: false
})
export class SubmitQuestionComponent implements OnInit {  
  @ViewChild(FormGroupDirective) questionformRef!: FormGroupDirective;
  questionform: FormGroup;
  cdnEndPoint: string = environment.cdnEndPoint;
  submitted: boolean = false;
  currentUser: UserAccount;
  date = Helpers.getFormattedCurrentDateWithoutTime();
  categorySource: Array<any> = [];
  isSuccess: boolean = false;
  currentUrl = this.router.url;  
  static readonly SUCCESS_MESSAGE = "Question sent successfully.";
  static readonly FAILURE_MESSAGE = "There was a problem sending your question. Please try again.";
  categoryDefaultItem: any = { CategoryName: '-- Select category --', _MessageCategoryID: '' };
  filteredData: any[] = [];
  constructor(
    public modal: NgbActiveModal,
    private formBuilder: FormBuilder,
    private securityService: SecurityService,
    private notificationService: TopNotificationService,
    private loaderService: LoaderService,
    private loggingService: LoggingService,
    private communicationService: CommunicationService,
    private router: Router,
    private portalService: PortalService,
    private routingService: RoutingService,    
  ) {
    this.currentUser = this.securityService.currentUserValue;
    this.questionform = this.formBuilder.group({
      category: ['', Validators.required],
      title: ['', Validators.required],
      question: ['', [Validators.required, Validators.maxLength(1000)]]
    });
  }

  ngOnInit(): void {    
    this.getMessageCategoriesByPortalID();
  }

  goToInbox() {
    this.modal.dismiss('');
    this.router.navigateByUrl(`/Go/${this.routingService.getSponsorName()}/${this.routingService.getPortalName()}/Communications/QuestionsInbox`)      
  }

  reload() {
    //window.top.location.reload();
    window.location.reload();
  }

  onSubmitQuestion() {    
    this.submitted = true;
    if (this.questionform.valid) {                 
      let postData: IQuestionModel = {
        MessageCategoryId: this.questionform.value.category,
        Title: this.questionform.value.title,
        Content: this.questionform.value.question
      };      
      this.loaderService.showLoader();
      this.loggingService.Info(
        `<MedPoint.WebApp.TriPort.Shared.Components.SubmitQuestionComponent.onSubmitQuestion> begins.`
      );
      setTimeout(() => {
      this.communicationService
        .submitQuestion(this.routingService.getSponsorName(), this.portalService.portalConfiguation?.value.PortalID!, postData)
          .then((response) => {
            if (response) {
              if (this.currentUrl.includes("Questions")) {
                this.modal.close();                
              }
              this.isSuccess = true;
              this.questionform.disable(); // disable all
              this.notificationService.showNotification(SubmitQuestionComponent.SUCCESS_MESSAGE, NotificationType.Success);
            }
            else {
              this.isSuccess = false;
              this.notificationService.showNotification(SubmitQuestionComponent.FAILURE_MESSAGE, NotificationType.Error);
            }            
          })
        .catch((err) => {
          this.isSuccess = false;
            this.loggingService.Error(
              `<MedPoint.WebApp.TriPort.Shared.Components.SubmitQuestionComponent.onSubmitQuestion> Failed with message=${JSON.stringify(err)}`
            );
          this.notificationService.showNotification(SubmitQuestionComponent.FAILURE_MESSAGE, NotificationType.Error);
          })
          .finally(() => {
            this.loggingService.Info(
              `<MedPoint.WebApp.TriPort.Shared.Components.SubmitQuestionComponent.onSubmitQuestion> ends.`
            );
            this.loaderService.hideLoader();
          });        
      }, 500);
    }
  }

  resetForm() {
    this.submitted = false;
    this.questionformRef.resetForm();
    this.isSuccess = false;
  }   

  getMessageCategoriesByPortalID() {    
    this.loaderService.showLoader();
    this.loggingService.Info(
      `<MedPoint.WebApp.TriPort.Shared.Compenents.SubmitQuestionComponent.getMessageCategoriesByPortalID> begins.`
    );
    this.communicationService
      .getMessageCategoriesByPortalID(this.routingService.getSponsorName(), this.portalService.portalConfiguation?.value.PortalID!)
      .then((categories) => {        
        this.filteredData = this.categorySource = categories;        
      })
      .catch((err) => {
        this.loggingService.Error(
          `<MedPoint.WebApp.TriPort.Shared.Compenents.SubmitQuestionComponent.getMessageCategoriesByPortalID> Failed with message=${JSON.stringify(err)}`
        );
      })
      .finally(() => {
        this.loggingService.Info(
          `<MedPoint.WebApp.TriPort.Shared.Compenents.SubmitQuestionComponent.getMessageCategoriesByPortalID> ends.`
        );
        this.loaderService.hideLoader();
      });

  }

  public filterData(filter: any): void {
    this.filteredData = this.categorySource.length > 0 ? this.categorySource.filter((s: any) => s.CategoryName.toLowerCase().indexOf(filter.toLowerCase()) !== -1) : [];
  }

}
